import { commentItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-2">
          观众热评
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          听听影迷们怎么说——真实用户的观影体验分享
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
          {commentItems.map((comment, idx) => (
            <div
              key={idx}
              className="rounded-lg border border-background-300/40 bg-background-50/70 p-5 md:p-6"
            >
              <div className="flex items-start gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-accent-500/20 flex items-center justify-center shrink-0">
                  <span className="text-accent-400 text-sm font-bold">
                    {comment.name.charAt(0)}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between flex-wrap gap-2">
                    <span className="text-sm font-semibold text-foreground-800">
                      {comment.name}
                    </span>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                  <div className="flex items-center gap-0.5 mt-1">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`ri-star-fill text-xs ${i < comment.rating ? 'text-accent-400' : 'text-foreground-300'}`}
                      ></i>
                    ))}
                  </div>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-700 mb-2">
                {comment.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {comment.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}